/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUpLeftSmall: {
  name: 'arrow_up_left_small';
  data: string;
} = {
  name: 'arrow_up_left_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M14.122 7.747a.75.75 0 0 1 0 1.5H10.31l5.471 5.473a.75.75 0 1 1-1.06 1.06l-5.472-5.472v3.814a.75.75 0 1 1-1.5 0V8.498a.75.75 0 0 1 .75-.75h5.624Z" fill="currentColor"/></svg>`
};
